import * as types from "./actionType";

const initialState = {
  loading: false,
  experienceLoading: false,
  experienceList: [],
  experienceListCount: 0,
  experiencePendingCount: 0,
  experienceDetails: null,
  createExperienceStatus: false,
  updatedDetails: null,
  fetchingUpdatedDetails: false,
  updateExperienceInfo: [],
};

function experienceReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_EXPERIENCE_LIST:
      return {
        ...state,
        loading: true,
        experienceLoading: true,
      };
    case types.FETCH_EXPERIENCE_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        experienceLoading: false,
        experienceList: action.payload,
        experienceListCount: action.count,
        experiencePendingCount: action.pendingCount
      };
    }
    case types.FETCH_EXPERIENCE_LIST_FAILED: {
      return {
        ...state,
        loading: false,
        experienceLoading: false,
        experienceList: [],
        experienceListCount: 0,
      };
    }
    case types.FETCH_EXPERIENCE_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_EXPERIENCE_DETAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        experienceDetails: action.payload,
      };
    }
    case types.FETCH_EXPERIENCE_DETAILS_FAILED: {
      return {
        ...state,
        loading: false,
        experienceDetails: {},
      };
    }
    case types.CREATE_EXPERIENCE:
      return {
        ...state,
        createExperienceStatus: true,
      };
    case types.CREATE_EXPERIENCE_SUCCESS: {
      return {
        ...state,
        createExperienceStatus: false,
      };
    }
    case types.CREATE_EXPERIENCE_FAILED: {
      return {
        ...state,
        createExperienceStatus: false,
      };
    }
    case types.UPDATE_EXPERIENCE:
      return {
        ...state,
        updateExperienceInfo: [],
      };
    case types.UPDATE_EXPERIENCE_SUCCESS: {
      return {
        ...state,
        updateExperienceInfo: action.payload,
      };
    }
    case types.UPDATE_EXPERIENCE_FAILED: {
      return {
        ...state,
        updateExperienceInfo: [],
      };
    }
    case types.EXPERIENCE_UPDATE_DETAILS:
      return {
        ...state,
        fetchingUpdatedDetails: true,
      };
    case types.EXPERIENCE_UPDATE_DETAILS_SUCCESS:
      return {
        ...state,
        fetchingUpdatedDetails: false,
        updatedDetails: action.payload,
      };
    case types.EXPERIENCE_UPDATE_DETAILS_FAILED:
      return {
        ...state,
        fetchingUpdatedDetails: false,
        updatedDetails: null,
      };
    default:
      return state;
  }
}

export default experienceReducer;
